<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between align-items-center">
            <h6>Monitoreo de Ruta: Tareas, Calor y Trayectoria</h6>
            <div class="d-flex gap-2">
              <input type="date" v-model="filterDate" class="form-control form-control-sm">
              <select v-model="selectedUser" class="form-select form-select-sm">
                <option :value="null">Seleccione Usuario</option>
                <option v-for="u in userList" :key="u.id" :value="u.id">{{ u.full_name }}</option>
              </select>
              <argon-button size="sm" color="primary" @click="fetchRoute">Ver Ruta</argon-button>
            </div>
          </div>
          <div class="card-body">
            <div id="route-map" style="height: 550px;" class="border-radius-lg shadow-sm"></div>

            <div class="mt-3 d-flex justify-content-center gap-4 flex-wrap border-bottom pb-3">
              <span class="text-xs"><i class="fa fa-map-marker text-success me-1"></i> Planificado</span>
              <span class="text-xs"><i class="fa fa-map-marker text-danger me-1"></i> Completado</span>
              <span class="text-xs"><i class="fa fa-minus text-info me-1"></i> Trayectoria (Línea)</span>
              <span class="text-xs"><i class="fa fa-fire text-warning me-1"></i> Calor</span>
            </div>

            <div class="row mt-4">
              <div class="col-md-3">
                <div class="card shadow-none border">
                  <div class="card-body p-3 text-center">
                    <h6 class="text-sm mb-0 text-uppercase font-weight-bold">Asignadas</h6>
                    <h5 class="font-weight-bolder text-primary mb-0">{{ totalAsignadas }}</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card shadow-none border">
                  <div class="card-body p-3 text-center">
                    <h6 class="text-sm mb-0 text-uppercase font-weight-bold">Completadas</h6>
                    <h5 class="font-weight-bolder text-success mb-0">{{ totalCompletadas }}</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card shadow-none border">
                  <div class="card-body p-3 text-center">
                    <h6 class="text-sm mb-0 text-uppercase font-weight-bold">Pendientes</h6>
                    <h5 class="font-weight-bolder text-danger mb-0">{{ totalPendientes }}</h5>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card shadow-none border">
                  <div class="card-body p-3 text-center">
                    <h6 class="text-sm mb-0 text-uppercase font-weight-bold">Recuperación</h6>
                    <h5 class="font-weight-bolder text-success mb-0">{{ totalRecuperado }} / {{ totalProyectado }} </h5>
                  </div>
                </div>
              </div>

            </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import 'leaflet.heat';
import axios from 'axios';
import moment from 'moment';
import ArgonButton from "@/components/ArgonButton.vue";
import { markRaw, toRaw } from 'vue';

export default {
  name: "UserDailyRoute",
  components: { ArgonButton },
  data() {
    return {
      map: null,
      currentUserLocation: null,
      refreshInterval: null,
      filterDate: moment().format('YYYY-MM-DD'),
      selectedUser: null,
      userList: [],
      tasks: [],
      // Capas
      heatLayer: null,
      markersGroup: null,
      polylineLayer: null,
      layerControl: null
    };
  },
  computed: {
    totalAsignadas() {
      return this.tasks.length;
    },
    totalCompletadas() {
      // Consideramos completada si tiene coordenadas de ejecución (latitude/longitude)
      return this.tasks.filter(t => t.latitude && t.longitude && parseFloat(t.latitude) !== 0).length;
    },
    totalPendientes() {
      return this.totalAsignadas - this.totalCompletadas;
    },
    totalProyectado() {
      // Consideramos completada si tiene coordenadas de ejecución (latitude/longitude)
      const total = this.tasks.reduce((acc, task) => {
      // Convertimos a float por si viene como string, si no existe o es nulo sumamos 0
      const valor = parseFloat(task.to_collect) || 0;
      return acc + valor;
    }, 0);

    // Opcional: Formateamos a 2 decimales
    return total.toFixed(2);
    },
    totalRecuperado() {
      const total = this.tasks.reduce((acc, task) => {
      // Convertimos a float por si viene como string, si no existe o es nulo sumamos 0
      const valor = parseFloat(task.collected) || 0;
      return acc + valor;
    }, 0);

    // Opcional: Formateamos a 2 decimales
    return total.toFixed(2);
    },
  },
  watch: {
    selectedUser(newVal) {
      if (this.refreshInterval) clearInterval(this.refreshInterval);
      this.currentUserLocation = null;
      this.tasks = [];
      if (newVal) this.startMonitoring();
    }
  },
  methods: {
    async fetchUsers() {
      try {
        const token = localStorage.getItem("accessToken");
        const companyId = localStorage.getItem('companyId');
        const roleId = localStorage.getItem('userLevel');
        const branchId = localStorage.getItem('branchId')
        let url = `${this.$store.state.apiURL}users?company=${companyId}`;

        // Si es tipo 2, agregamos el branch_id para que el supervisor solo vea a su equipo
        if (parseInt(roleId) === 2 && branchId && branchId !== 'null') {
          url += `&fk_branch_id=${branchId}`;
        }

        const res = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        this.userList = res.data.filter(x=> x.role_id==3 && x.is_active==1);
      } catch (e) { console.error("Error al obtener usuarios", e); }
    },

    initMap() {
      const mapInstance = L.map('route-map').setView([12.1328, -86.2504], 13);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors'
      }).addTo(mapInstance);

      const markersGroup = L.featureGroup();
      const polylineLayer = L.polyline([], { color: '#007bff', weight: 3, opacity: 0.7, dashArray: '10, 5' });
      const heatLayer = L.heatLayer([], { radius: 20, blur: 15 });

      markersGroup.addTo(mapInstance);
      polylineLayer.addTo(mapInstance);
      heatLayer.addTo(mapInstance);

      const overlays = {
        "📍 Marcadores de Tareas": markersGroup,
        "🛣️ Trayectoria (Línea)": polylineLayer,
        "🔥 Mapa de Calor": heatLayer
      };

      L.control.layers(null, overlays, { collapsed: false }).addTo(mapInstance);

      this.map = markRaw(mapInstance);
      this.markersGroup = markRaw(markersGroup);
      this.polylineLayer = markRaw(polylineLayer);
      this.heatLayer = markRaw(heatLayer);
    },

    async fetchHeatmapAndPath() {
      if (!this.selectedUser) return;
      try {
        const data = await this.fetchTaskReportData('all_tracking_data', this.filterDate, this.filterDate);
        const coords = data.map(p => [parseFloat(p.latitude), parseFloat(p.longitude)]);

        toRaw(this.heatLayer).setLatLngs(coords.map(c => [...c, 0.5]));
        toRaw(this.polylineLayer).setLatLngs(coords);
      } catch (e) { console.error("Error al traer rastro GPS", e); }
    },

    async fetchRoute() {
      if (!this.selectedUser) return;
      const token = localStorage.getItem("accessToken");
      const companyId = localStorage.getItem('companyId');
      const roleId = localStorage.getItem('userLevel');
      const branchId = localStorage.getItem('branchId');
      try {
        const params = {
          type: 'user_detail',
          company_id: companyId,
          user_id: this.selectedUser,
          start_date: this.filterDate,
          end_date: this.filterDate
        };

        if (parseInt(roleId) === 2 && branchId && branchId !== 'null') {
          params.branch_id = branchId;
        }

        const res = await axios.get(`${this.$store.state.apiURL}reports/tasks`, {
          params,
          headers: { 'Authorization': `Bearer ${token}` }
        });
        this.tasks = res.data;

        await this.fetchHeatmapAndPath();
        this.drawMarkers();
      } catch (e) { console.error("Error al cargar ruta", e); }
    },

    async fetchUserRealtimeLocation() {
      if (!this.selectedUser) return;
      const data = await this.fetchTaskReportData('realtime_monitoring', this.filterDate, this.filterDate);
      const userData = data.find(u => u.user_id == this.selectedUser);

      if (userData && userData.last_lat && userData.last_lng) {
        this.currentUserLocation = {
          lat: parseFloat(userData.last_lat),
          lng: parseFloat(userData.last_lng),
          lastSeen: userData.last_seen,
          name: userData.user_name
        };
        this.drawMarkers();
      }
    },

    async fetchTaskReportData(reportType, startDate, endDate) {
      const token = localStorage.getItem("accessToken");
      const apiURL = this.$store.state.apiURL;
      const companyId = localStorage.getItem("companyId");
      const roleId = localStorage.getItem('userLevel');
      const branchId = localStorage.getItem('branchId');
      const params = { company_id: companyId, type: reportType, start_date: startDate, end_date: endDate, user_id: this.selectedUser };
      // Si es tipo 2, agregamos branch_id para validar en el backend
      if (parseInt(roleId) === 2 && branchId && branchId !== 'null') {
        params.branch_id = branchId;
      }
      const queryString = new URLSearchParams(params).toString();
      const response = await axios.get(`${apiURL}reports/tasks?${queryString}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      return response.data || [];
    },

    async startMonitoring() {
      await this.fetchRoute();
      if (this.refreshInterval) clearInterval(this.refreshInterval);
      this.refreshInterval = setInterval(async () => {
        await this.fetchUserRealtimeLocation();
        await this.fetchHeatmapAndPath();
      }, 30000);
    },

    drawMarkers() {
      const rawMap = toRaw(this.map);
      const rawGroup = toRaw(this.markersGroup);
      if (!rawMap || !rawGroup) return;

      rawGroup.clearLayers();

      const greenIcon = L.icon({ iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png', iconSize: [25, 41], iconAnchor: [12, 41] });
      const redIcon = L.icon({ iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png', iconSize: [25, 41], iconAnchor: [12, 41] });
      const blueIcon = L.icon({ iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png', iconSize: [25, 41], iconAnchor: [12, 41] });

      this.tasks.forEach(t => {
        if (t.plan_lat && t.plan_lng) {
          L.marker([t.plan_lat, t.plan_lng], { icon: greenIcon }).bindPopup(`Planificado: ${t.task_description}`).addTo(rawGroup);
        }
        if (t.latitude && t.longitude && parseFloat(t.latitude) !== 0) {
          L.marker([t.latitude, t.longitude], { icon: redIcon }).bindPopup(`Completado: ${t.task_description}<br>Hora: ${t.completed_at}`).addTo(rawGroup);
        }
      });

      if (this.currentUserLocation) {
        L.marker([this.currentUserLocation.lat, this.currentUserLocation.lng], { icon: blueIcon, zIndexOffset: 1000 })
          .bindPopup(`<b>${this.currentUserLocation.name}</b><br>📍 Ubicación Actual`).addTo(rawGroup);
      }

      setTimeout(() => {
        if (rawGroup.getLayers().length > 0) rawMap.fitBounds(rawGroup.getBounds().pad(0.2));
      }, 200);
    }
  },
  mounted() { this.initMap(); this.fetchUsers(); },
  beforeUnmount() { if (this.refreshInterval) clearInterval(this.refreshInterval); }
};
</script>

<style scoped>
#route-map { background: #f8f9fa; z-index: 1; }
:deep(.leaflet-control-layers) { border-radius: 8px; padding: 6px; box-shadow: 0 2px 10px rgba(0,0,0,0.15); }
</style>